import React from "react";
import Hero from "../components/Contact Us/GetInTouch";
import LetsTalk from "../components/Contact Us/Let'sTalk";
import { Helmet } from "react-helmet-async";
// const LetTalk = React.lazy(() => import("../components/Contact Us/Let'sTalk.jsx"));

class ContactUsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Only catch suspense-related errors
    if (error.message && error.message.includes('suspended')) {
      return { hasError: true };
    }
    throw error; // Re-throw other errors
  }

  componentDidCatch(error, errorInfo) {
    if (error.message && error.message.includes('suspended')) {
      console.warn('Suspense error caught and handled:', error);
      // Optionally reload the page after a brief delay
      setTimeout(() => window.location.reload(), 100);
    }
  }

  render() {
    if (this.state.hasError) {
      // Return the components without the problematic part
      return (
        <>
          <Hero />
          <LetsTalk />
        </>
      );
    }

    return this.props.children;
  }
}
const ContactUs = () => {
  return (
    <>
    <ContactUsErrorBoundary>
      {/*metadata for SEO */}
      <Helmet>
        <title>Contact | DevAngles</title>
        <meta name="description" content="Connect with DevAngles." />
       
        <link rel="canonical" href="https://www.devangles.com/contact/" />
        <link rel="dns-prefetch" href="https://www.devangles.com" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      </Helmet>
      <Hero />
      <LetsTalk />
      </ContactUsErrorBoundary>
    </>
  );
};

export default ContactUs;
